import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject, input } from '@angular/core';
import { ButtonComponent } from '../../../../../../../../shared/components/button/button.component';

@Component({
  selector: 'app-smart-fix-image-modal',
  imports: [ButtonComponent],
  standalone: true,
  styleUrl: './smart-fix-image-attach-modal.component.scss',
  templateUrl: './smart-fix-image-attach-modal.component.html',
})
export class SmartFixImageAttachModal {
  sentImage = input<any>(inject(DIALOG_DATA)?.sentImage);
  constructor(public dialogRef: DialogRef<boolean>) {}

  fadeAndClose(container: HTMLElement) {
    container.classList.add('fade-out');
    setTimeout(() => this.dialogRef.close(), 300);
  }
}
